import { Input as MantineInput } from '@mantine/core';

export const Input = MantineInput.extend({
	defaultProps: {
		variant: 'primary',
	},
});
